import { Card, CardContent, Avatar } from "@mui/material";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import PropTypes from "prop-types";
import { blue, green, red, purple } from "@mui/material/colors";

const StatCard = ({ title, stats }) => {
  // कुछ random colors icon circles के लिए
  const colors = [blue[500], green[500], red[500], purple[500]];

  return (
    <Card
      sx={{
        borderRadius: "20px",
        boxShadow: "0px 6px 18px rgba(0,0,0,0.12)",
        p: 2,
        transition: "all 0.3s ease",
        "&:hover": {
          transform: "translateY(-5px)",
          boxShadow: "0px 8px 24px rgba(0,0,0,0.2)",
        },
      }}
    >
      <CardContent>
        {/* Card Title */}
        <ArgonTypography
          variant="h6"
          fontWeight="bold"
          color="dark"
          sx={{ mb: 3, textAlign: "center", letterSpacing: "0.5px" }}
        >
          {title}
        </ArgonTypography>

        {/* Stats Rows */}
        {stats.map((item, index) => (
          <ArgonBox
            key={index}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mb={2}
            p={1.5}
            sx={{
              borderRadius: "12px",
              backgroundColor: "rgba(245, 245, 245, 0.8)",
            }}
          >
            {/* Icon Circle */}
            <Avatar
              sx={{
                bgcolor: colors[index % colors.length],
                width: 36,
                height: 36,
                fontSize: "0.9rem",
                fontWeight: "bold",
              }}
            >
              {index + 1}
            </Avatar>

            {/* Label */}
            <ArgonTypography
              variant="button"
              color="text"
              fontWeight="medium"
              sx={{ flex: 1, ml: 2 }}
            >
              {item.label}
            </ArgonTypography>

            {/* Value */}
            <ArgonTypography
              variant="body1"
              color="dark"
              fontWeight="bold"
              sx={{ fontSize: "1.1rem" }}
            >
              {item.value}
            </ArgonTypography>
          </ArgonBox>
        ))}
      </CardContent>
    </Card>
  );
};

StatCard.propTypes = {
  title: PropTypes.string.isRequired,
  stats: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    })
  ).isRequired,
};

export default StatCard;
